'use client'

import { useCallback, useEffect, useState } from 'react'

const scrollEvents = ['wheel', 'touchmove', 'touchstart']

const useLockScroll = ({ targetId }) => {
    const [targetElement, setTargetElement] = useState<HTMLElement | null>(null)

    const handleScroll = useCallback((e) => {
        e.preventDefault()
    }, [])

    const lockScroll = useCallback(() => {
        scrollEvents.forEach((event) => {
            targetElement?.addEventListener(event, handleScroll)
        })
    }, [handleScroll, targetElement])

    const unLockScroll = useCallback(() => {
        scrollEvents.forEach((event) => {
            targetElement?.removeEventListener(event, handleScroll)
        })
    }, [handleScroll, targetElement])

    useEffect(() => {
        const targetIdElement = document.getElementById(targetId)
        setTargetElement(targetIdElement)

        return () => {
            if (targetElement) {
                unLockScroll()
            }
        }
    }, [targetId, targetElement, lockScroll, unLockScroll])

    return { lockScroll, unLockScroll }
}

function LockScroll({ targetId }) {
    const { lockScroll, unLockScroll } = useLockScroll({
        targetId,
    })

    useEffect(() => {
        lockScroll()
        return () => {
            unLockScroll()
        }
    }, [lockScroll, unLockScroll])
    return null
}

export { LockScroll, useLockScroll }
